import useColors from "../customHooks/useColors.js";

const BaseCheckbox = ({
  children,
  value = false,
  onChange = () => {},
  disabled = false,
  style = {}, //style ide na checkbox
}) => {
  const [currentColors] = useColors();

  const handleChange = disabled ? () => {} : onChange;

  const styles = {
    checkboxRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
     
    },
    checkboxContainer: {
      flex: 15,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
    },
    checkbox: {
      accentColor: currentColors.primary,
      width: "50%",
      cursor: "pointer",
      marginTop: "8px"
    },
    checkboxLabelContainer: {
      flex: 85,
      marginRight: "1em",
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
    },
  };

  return (
    <div style={styles.checkboxRow}>
      <div style={styles.checkboxContainer}>
        <input
          style={{ ...styles.checkbox, ...style }}
          type="checkbox"
          disabled={disabled}
          checked={value}
          value={value}
          onChange={handleChange}
        />
      </div>
      <div style={styles.checkboxLabelContainer} onClick={handleChange}>
        <label style={{ cursor: "pointer" }}>{children}</label>
      </div>
    </div>
  );
};

export default BaseCheckbox;
